import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import nativeToast from "native-toast";

Vue.use(Router);

let router = new Router({
  mode: "history",
  routes: [
    /////////////////////////////////////////////////////////////////
    //                          ADMIN
    /////////////////////////////////////////////////////////////////
    {
      path: "/addmoney",
      component: () => import("./views/admin/addmoney.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/addmoney/:email",
      component: () => import("./views/admin/addmoney.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/alldeposit",
      component: () => import("./views/admin/alldeposit.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/alltransactions",
      component: () => import("./views/admin/alltransactions.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/transfertx",
      component: () => import("./views/admin/transfertx.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/investtx",
      component: () => import("./views/admin/investtx.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/allusers",
      component: () => import("./views/admin/allusers.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/allwithdraw",
      component: () => import("./views/admin/allwithdraw.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/announce",
      component: () => import("./views/admin/announce.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/currency",
      component: () => import("./views/admin/currency.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/admin",
      component: () => import("./views/admin/index.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/reset2fa",
      component: () => import("./views/admin/reset2fa.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/reset2fa/:email",
      component: () => import("./views/admin/reset2fa.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/settingnode",
      component: () => import("./views/admin/settingnode.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/systemfeed",
      component: () => import("./views/admin/systemfeed.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/txrelation",
      component: () => import("./views/admin/txrelation.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/txrelation/:tx_id",
      component: () => import("./views/admin/txrelation.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/user",
      component: () => import("./views/admin/user.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/user/:email",
      component: () => import("./views/admin/user.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/usertx/:email",
      component: () => import("./views/admin/usertx.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/adjustfee",
      component: () => import("./views/admin/adjustfee.vue"),
      meta: { requiresAuth: true },
    },
    /////////////////////////////////////////////////////////////////
    //                          EXCHANGE
    /////////////////////////////////////////////////////////////////
    {
      path: "/advanced/:pair",
      component: () => import("./views/exchange/advanced.vue"),
    },
    {
      path: "/",
      component: () => import("./views/exchange/home.vue"),
    },
    {
      path: "/chart/:pair",
      component: () => import("./views/exchange/chart.vue"),
    },
    {
      path: "/favorite/",
      component: () => import("./views/exchange/favorite.vue"),
    },
    {
      path: "/market/",
      component: () => import("./views/exchange/market.vue"),
    },
    {
      path: "/openorders",
      component: () => import("./views/exchange/openorders.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/orderhistory",
      component: () => import("./views/exchange/orderhistory.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/trade/:pair",
      component: () => import("./views/exchange/trade.vue"),
    },

    /////////////////////////////////////////////////////////////////
    //                          INVESTBOX
    /////////////////////////////////////////////////////////////////
    {
      path: "/allinvestbox",
      component: () => import("./views/investbox/allinvestbox.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/confirminvest/:investid",
      component: () => import("./views/investbox/confirminvest.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/createinvest",
      component: () => import("./views/investbox/createinvest.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/myinvest",
      component: () => import("./views/investbox/myinvest.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/staking",
      component: () => import("./views/investbox/staking.vue"),
    },
    {
      path: "/swapping",
      component: () => import("./views/investbox/swapping.vue"),
    },
    {
      path: "/updateinvest",
      component: () => import("./views/investbox/updateinvest.vue"),
      meta: { requiresAuth: true },
    },
    /////////////////////////////////////////////////////////////////
    //                          PAGE
    /////////////////////////////////////////////////////////////////
    {
      path: "/about",
      component: () => import("./views/page/about.vue"),
    },
    {
      path: "/api",
      component: () => import("./views/page/api.vue"),
    },
    {
      path: "/api-private",
      component: () => import("./views/page/api-private.vue"),
    },
    {
      path: "/fee",
      component: () => import("./views/page/fee.vue"),
    },
    {
      path: "/page",
      component: () => import("./views/page/index.vue"),
    },
    {
      path: "/language",
      component: () => import("./views/page/language.vue"),
    },
    {
      path: "/listing",
      component: () => import("./views/page/listing.vue"),
    },
    {
      path: "/news",
      component: () => import("./views/page/news.vue"),
    },
    {
      path: "/partner",
      component: () => import("./views/page/partner.vue"),
    },
    {
      path: "/privacy",
      component: () => import("./views/page/privacy.vue"),
    },
    {
      path: "/support",
      component: () => import("./views/page/support.vue"),
    },
    {
      path: "/referral",
      component: () => import("./views/page/referral.vue"),
    },
    {
      path: "/terms",
      component: () => import("./views/page/terms.vue"),
    },
    /////////////////////////////////////////////////////////////////
    //                          SECURITY
    /////////////////////////////////////////////////////////////////
    {
      path: "/changepassword",
      component: () => import("./views/security/changepassword.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/googleauthen",
      component: () => import("./views/security/googleauthen.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/security",
      component: () => import("./views/security/index.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/logs",
      component: () => import("./views/security/logs.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/mailconfirm",
      component: () => import("./views/security/mailconfirm.vue"),
      meta: { requiresAuth: true },
    },
    /////////////////////////////////////////////////////////////////
    //                          SITE
    /////////////////////////////////////////////////////////////////
    {
      path: "*",
      component: () => import("./views/site/pagenotfound.vue"),
    },
    {
      path: "/emailverification/:email",
      component: () => import("./views/site/emailverification.vue"),
    },
    {
      path: "/emailverificationresult/:result",
      component: () => import("./views/site/emailverificationresult.vue"),
    },
    {
      path: "/newpasswordsent",
      component: () => import("./views/site/newpasswordsent.vue"),
    },
    {
      path: "/resetpassword",
      component: () => import("./views/site/resetpassword.vue"),
    },
    {
      path: "/resetpasswordverification",
      component: () => import("./views/site/resetpasswordverification.vue"),
    },
    {
      path: "/signin",
      component: () => import("./views/site/signin.vue"),
    },
    {
      path: "/signup",
      component: () => import("./views/site/signup.vue"),
    },
    {
      path: "/r/:ref",
      component: () => import("./views/site/signup.vue"),
    },
    /////////////////////////////////////////////////////////////////
    //                      TRANSPARENCY
    /////////////////////////////////////////////////////////////////
    {
      path: "/funds",
      component: () => import("./views/transparency/fundsholding.vue"),
    },
    {
      path: "/funds/:currency",
      component: () => import("./views/transparency/funds.vue"),
    },
    {
      path: "/fundsummary",
      component: () => import("./views/transparency/fundsummary.vue"),
      meta: { requiresAuth: true },
    },
    /////////////////////////////////////////////////////////////////
    //                          USER
    /////////////////////////////////////////////////////////////////
    {
      path: "/affiliate",
      component: () => import("./views/user/affiliate.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/setting",
      component: () => import("./views/user/setting.vue"),
    },
    /////////////////////////////////////////////////////////////////
    //                          WALLET
    /////////////////////////////////////////////////////////////////
    {
      path: "/balance",
      component: () => import("./views/wallet/balance.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/balancedetail/:currency",
      component: () => import("./views/wallet/balancedetail.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/confirmwithdraw",
      component: () => import("./views/wallet/confirmwithdraw.vue"),
    },
    {
      path: "/deposit/:currency",
      component: () => import("./views/wallet/deposit.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/deposithistory",
      component: () => import("./views/wallet/deposithistory.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/receive",
      component: () => import("./views/wallet/receive.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/transactions",
      component: () => import("./views/wallet/transactions.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/transfer",
      component: () => import("./views/wallet/transfer.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/transfer/:currency",
      component: () => import("./views/wallet/transfer.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/transfer/:currency/:address/:amount",
      component: () => import("./views/wallet/transfer.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/withdraw/:currency",
      component: () => import("./views/wallet/withdraw.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/withdrawhistory",
      component: () => import("./views/wallet/withdrawhistory.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/withdrawresult/:result",
      component: () => import("./views/wallet/withdrawresult.vue"),
    },
  ],
});

router.beforeEach((to, from, next) => {
  const currentUser = store.getters.isAuthenticated;
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) {
    next("/signin");
    nativeToast({
      message: "Please sign in.",
      position: "top",
      timeout: 3000,
      type: "error",
    });
  } else if (requiresAuth && currentUser) {
    next();
  } else {
    next();
  }
});

export default router;
